import $ from 'jquery';
import { initImageUpload } from "./imageupload";

export function initZelftestAdmin() {

    var $container = $(".plugin-scan-admin");
    var adviceOpen = false;
    var questionOpen = false;

    $container.scanAdminManager();
    $container.on("rendered", function (e) {
        //MJ: init color dropdown
        $container.find(".select-color .select2").each(function (idx, el) {
            var $this = $(el);
            var $option = $("<option></option>").attr("value", -1).text("Volgende vraag");

            for (var i = 1; i < 10; i++) {
                var val = "color-" + i;
                $option = $("<option></option>").attr("value", val);
                if (val == $this.attr("data-value")) {
                    $option.attr("selected", "SELECTED");
                }
                $this.append($option);
            }
        }).select2({
            minimumResultsForSearch: -1,
            width: '100%',
            dropdownParent: $('.zelftest'),
            templateResult: function (data) {
                return "<span class=\"" + data.id + "\"></span>";
            },
            templateSelection: function (data) {
                return "<span class=\"" + data.id + "\"></span>";
            },
            escapeMarkup: function (markup) {
                return markup;
            }
        }).on("select2:select", function (e) {

            $container.scanAdminManager("rememberChange", $(e.target).data(), $(e.params.data.element).val());
            $container.scanAdminManager("renderChapter", $(e.target).data("idx_chapter"));
        });

        $container.find(".select-curriculum").each(function (idx, el) {

            var $cursel = $(el);
            var curriculum_meta = $container.scanAdminManager("getQuestion", $cursel.attr("data-idx_chapter"), $cursel.attr("data-idx_question")).curriculum_meta;

            for (var i = 0; i < curriculum_meta.length; i++) {
                const $option = $("<option>" + curriculum_meta[i].text + "</option>").attr("value", curriculum_meta[i].id);
                $cursel.append($option);
            }

            $cursel.select2({
                multiple: true, dropdownAutoWidth: true, width: '100%', ajax: {
                    url: zmp_ajax.ajaxurl, data: function (params) {
                        var query = {
                            action: "zmp_find_curriculum", q: params.term
                        };

                        // Query parameters will be ?search=[term]&type=public
                        return query;
                    }
                }
            }).on("select2:select", function (e) {
                $container.scanAdminManager("rememberChange", $(e.target).data(), $(e.target).select2('data').map(function (val, i) {
                    return parseInt(val.id);
                }));
            }).val(curriculum_meta.map(function (val, i) {
                return parseInt(val.id);
            })).trigger('change');

        });

        const $edit_cluster_container = $container.find("#edit-cluster");
        initImageUpload($edit_cluster_container.find(".fileupload"), $edit_cluster_container, $edit_cluster_container.find("form"), function (e, data) {
            var success = data.result.success;
            if (typeof success == 'undefined') {
                $edit_cluster_container.find(".fileinput-button .plugin-listen").val(data.result.url).trigger('blur');
                $edit_cluster_container.find(".media-preview").html("<img src=\"" + data.result.url + "\" />");
            } else {
                if (!success) {
                    $edit_cluster_container.find(".alert-imageuploadfailed").removeClass('d-none');
                }
            }
        });

        const $admin_container = $container.find("#admin");
        initImageUpload($admin_container.find(".fileupload"), $admin_container, $admin_container.find("form"), function (e, data) {
            var success = data.result.success;
            if (typeof success == 'undefined') {
                $admin_container.find(".fileinput-button .plugin-listen").val(data.result.url).trigger('blur');
                $admin_container.find(".media-preview").html("<img src=\"" + data.result.url + "\" />");
            } else {
                if (!success) {
                    $admin_container.find(".alert-imageuploadfailed").removeClass('d-none');
                }
            }
        });


        //MJ: init edit chapter button
        $container.find(".btn-edit-chapter").off("click");
        $container.find(".btn-edit-chapter").on("click", function (e) {
            e.preventDefault();
            var $this = $(this);
            $container.scanAdminManager("renderChapter", $this.attr("data-idx"));
        });

        //MJ move question buttons
        $container.find(".btn-move-question-down").last().remove();
        $container.find(".btn-move-question-down").off("click");
        $container.find(".btn-move-question-down").on("click", function (e) {
            e.preventDefault();
            var $this = $(this);
            $container.scanAdminManager("moveQuestion", parseInt($this.attr("data-idx_chapter") ?? ''), parseInt($this.attr("data-idx_question") ?? ''), parseInt($this.attr("data-idx_question") ?? '') + 1);
        });


        $container.find(".btn-move-question-up").first().remove();
        $container.find(".btn-move-question-up").off("click");
        $container.find(".btn-move-question-up").on("click", function (e) {
            e.preventDefault();
            var $this = $(this);
            $container.scanAdminManager("moveQuestion", parseInt($this.attr("data-idx_chapter") ?? ''), parseInt($this.attr("data-idx_question") ?? ''), parseInt($this.attr("data-idx_question") ?? '') - 1);
        });


        $container.find(".btn-remove-question").off("click");
        $container.find(".btn-remove-question").on("click", function (e) {
            e.preventDefault();
            var $this = $(this);
            $container.scanAdminManager("removeQuestion", parseInt($this.attr("data-idx_chapter") ?? ''), parseInt($this.attr("data-idx_question") ?? ''));
        });

        //MJ: chapter cancel button
        $container.find(".btn-cancel-chapter, .btn-cancel").off("click");
        $container.find(".btn-cancel-chapter, .btn-cancel").on("click", function (e) {
            e.preventDefault();
            var $this = $(this);
            $container.scanAdminManager("revert");
            $container.scanAdminManager("renderScan");
        });

        //MJ: chapter cancel button
        $container.find(".btn-save-chapter, .btn-save").off("click");
        $container.find(".btn-save-chapter, .btn-save").on("click", function (e) {
            e.preventDefault();
            var $this = $(this);
            $container.scanAdminManager("saveData");
            //$container.scanAdminManager("renderScan");
        });

        //MJ: chapter cancel button
        $container.find(".plugin-listen").off("blur");
        $container.find(".plugin-listen").on("blur", function (e) {
            e.preventDefault();
            var $this = $(this);

            $container.scanAdminManager("rememberChange", $this.data(), $this.val());

        });

        $container.find(".plugin-listen-checkbox").off("change");
        $container.find <HTMLInputElement>(".plugin-listen-checkbox").on("change", function (e) {
            e.preventDefault();
            const $this = $(this);

            $container.scanAdminManager("rememberChange", $this.data(), this.checked);

        });

        //MJ: chapter cancel button
        $container.find(".btn-chapter-new-question").off("click");
        $container.find(".btn-chapter-new-question").on("click", function (e) {
            e.preventDefault();
            var $this = $(this);
            $container.scanAdminManager("newQuestion", $this.attr("data-idx_chapter"));
            $container.scanAdminManager("renderChapter", $this.attr("data-idx_chapter"));

        });

        //MJ: chapter cancel button
        $container.find(".btn-new-chapter").off("click");
        $container.find(".btn-new-chapter").on("click", function (e) {
            e.preventDefault();

            var $this = $(this);
            $container.scanAdminManager("newChapter");
            //$container.scanAdminManager("renderChapter",$this.attr("data-idx_chapter") );

        });

        $container.find(".select-next-question").each(function (idx, el) {

            var $this = $(el);
            var total = $container.scanAdminManager("getQuestionCount", parseInt($this.attr("data-idx_chapter") ?? ''));
            var current_question = parseInt($this.attr("data-idx_question") ?? '');
            var selected = parseInt($this.attr("data-value") ?? '');
            var $option = $("<option></option>").attr("value", -1).text("Volgende vraag");
            if (selected == -1) {
                $option.attr("selected", "SELECTED");
            }
            $this.append($option);
            for (var i = current_question + 2; i < total; i++) {
                $option = $("<option></option>").attr("value", i).text("Vraag " + (i + 1));
                if (selected == i) {
                    $option.attr("selected", "SELECTED");
                }
                $this.append($option);
            }

        });
        if (adviceOpen == false) {
            $(".advices").addClass("d-none");
            $(".advice-title").removeClass("active");
        }
        if (questionOpen == false) {
            $(".questions").addClass("d-none");
            $(".question-title").removeClass("active");
        }
        //JR: init slide advice and questions on click
        $(".advice-title").on("click", function (e) {
            if (adviceOpen == false) {
                adviceOpen = true;
                $(".advices").removeClass("d-none");
                $(".advices").slideDown("fast");
                $(".advice-title").addClass("active");
            } else {
                adviceOpen = false;
                $(".advices").addClass("d-none");
                $(".advices").slideUp("fast");
                $(".advice-title").removeClass("active");
            }
        });

        $(".question-title").on("click", function (e) {
            if (questionOpen == false) {
                var $this = $(this);
                questionOpen = true;
                $("html,body").scrollTo($this, 200, 140);
                $(".questions").slideDown("fast");
                $(".question-title").addClass("active");
                $(".questions").removeClass("d-none");
            } else {
                questionOpen = false;
                $(".questions").slideUp("fast");
                $(".question-title").removeClass("active");
                $(".questions").addClass("d-none");
            }
        });

    });

}
